import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[ttInputPrefix]',
  standalone: true,
})
export class InputPrefixDirective {
  @HostBinding('class.tt-input-prefix') TTInputPrefix = true;
}
